import React from "react";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { GameScreen } from "../../../components/GameScreen";
import { MassiveTitle } from "../../../components/Title";
import { Text } from "../../../components/Text";

export interface RoundStartInterstitialProps {
  roundNumber: number;
}

const MainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled(MassiveTitle)`
  text-align: center;
`;

const HintText = styled(Text)`
  text-align: center;
  padding: 4px 32px;
`;

export const RoundStartInterstitial: React.FunctionComponent<RoundStartInterstitialProps> = React.memo(
  ({ roundNumber }) => {
    const { t } = useTranslation();

    const renderBody = React.useCallback(() => {
      return (
        <MainContainer id="gamePose">
          <Title>
            {t("roundStartInterstitial.roundNumber", { number: roundNumber })}
          </Title>
          <HintText subtle>{t("roundStartInterstitial.hint")}</HintText>
        </MainContainer>
      );
    }, [roundNumber, t]);

    return <GameScreen renderBody={renderBody} />;
  }
);
